import { render, staticRenderFns } from "./BooleanColumn.vue?vue&type=template&id=1b390ec8&scoped=true&"
import script from "./BooleanColumn.vue?vue&type=script&lang=js&"
export * from "./BooleanColumn.vue?vue&type=script&lang=js&"
import style0 from "./BooleanColumn.vue?vue&type=style&index=0&id=1b390ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b390ec8",
  null
  
)

export default component.exports